import { AfterContentInit, Component } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ActivatedRoute } from '@angular/router'
import { environment } from '../../../../environments/environment'
import {
    AcceptBookingRequest,
    AssignBookingReferenceCommand,
    BookingStatus, ConfirmBookingAcceptGQL, ConfirmBookingAssignReferenceGQL, ConfirmBookingDeclineGQL,
    ConfirmBookingGQL, DeclineBookingRequest,
    PublicBooking
} from '../../../../graphql'
import { UnsubscribeOnDestroy } from '../../../utility'

@Component({
    selector: 'app-confirm-booking',
    templateUrl: 'confirm-booking.html',
    styleUrls: ['confirm-booking.scss']
})
export class ConfirmBookingComponent extends UnsubscribeOnDestroy implements AfterContentInit {
    loading = true
    bookingId: string
    booking: PublicBooking
    bookingReference: string

    nameControl: FormControl

    // Constructor
    constructor(private _activatedRoute: ActivatedRoute,
                private _acceptBookingGQL: ConfirmBookingAcceptGQL,
                private _declineBookingGQL: ConfirmBookingDeclineGQL,
                private _assignBookingReferenceGQL: ConfirmBookingAssignReferenceGQL,
                private _bookingGQL: ConfirmBookingGQL,
                private _snackBar: MatSnackBar) {
        super()

        this._subscriptions.push(this._activatedRoute.paramMap.subscribe(paramMap => {
            this.bookingId = paramMap.get('bookingId')

            this._subscriptions.push(this._bookingGQL
                .watch({ bookingId: this.bookingId }, { fetchPolicy: 'no-cache' })
                .valueChanges
                .subscribe(result => {
                    if (!result.loading) {
                        this.loading = false
                        this.booking = result.data['publicBooking'] as PublicBooking
                        this.bookingReference = this.booking.bookingReference
                    }
                }))
        }))
    }

    ngAfterContentInit(): void {
        this.nameControl = new FormControl(this.bookingReference, Validators.required)
    }

    acceptBooking() {
        if (!this.nameControl.valid) { return }

        const command = {
            bookingId: this.bookingId,
            bookingReference: this.nameControl.value
        } as AssignBookingReferenceCommand

        this._subscriptions.push(this._assignBookingReferenceGQL.mutate({ input: command }).subscribe(result => {
            if (result?.errors?.length) {
                let message = 'There was an error assigning the booking reference: ' + result.errors[0].message
                this._snackBar.open(message, 'Dismiss')
                throw new Error(message)
            }

            this.nameControl.markAsPristine()

            const command: AcceptBookingRequest = {
                bookingId: this.bookingId,
                returnUrl: `${environment.memberUrl}my-trips/${this.booking.tripId}`,
                hostingTeamReturnUrl: `${environment.memberUrl}my-guests/${this.bookingId}`
            }

            this._subscriptions.push(this._acceptBookingGQL
                .mutate({ input: command })
                .subscribe(async response => {
                    this.loading = false
                    this._snackBar.open('Thank you for accepting the booking request', 'OK')
            }))
        }))
    }

    declineBooking() {
        const command: DeclineBookingRequest = {
            bookingId: this.bookingId,
            returnUrl: `${environment.memberUrl}search-listings`,
            reason: 'Declined by hotel'
        }

        this._subscriptions.push(this._declineBookingGQL
            .mutate({ input: command })
            .subscribe(async response => {
                if (response.errors && response.errors.length) {
                    this._snackBar.open('There was an error declining the booking, please try again later')
                    return
                }
            }))
    }


    protected readonly BookingStatus = BookingStatus
}
